function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
export var WINDOW_DATALAYER_PROPERTY = 'tc_vars';
export var DATALAYER_READY_EVENT = 'TMSDataLayerReady';
var dispatchTmsEvent = function dispatchTmsEvent(target, eventType, value) {
  var tmsEvent = new CustomEvent('TMSEvent', {
    detail: {
      eventType: eventType,
      value: value
    }
  });
  target.dispatchEvent(tmsEvent);
};

/**
 * Function to send event to analytical tools. If the TMS is not loaded, this function wait for the TMS "ready" signal before sending the data.
 * @param {HTMLElement} target Element initiating the event (ex: a button)
 * @param {string} eventType Event type
 * @param {Record<string, unknown>|string} data Record or stringified JSON with all key/value pairs
 */
export var hitEventTms = function hitEventTms(target, eventType) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (typeof data === 'string') {
    data = JSON.parse(data);
  }
  if (window[WINDOW_DATALAYER_PROPERTY] && window[WINDOW_DATALAYER_PROPERTY].cdl_datalayer_ready === true) {
    dispatchTmsEvent(target, eventType, data);
  } else {
    window.addEventListener(DATALAYER_READY_EVENT, function () {
      // Timeout at 0 to delay this listener after others that uses TMS "ready" signal
      setTimeout(function () {
        dispatchTmsEvent(target, eventType, data);
      }, 0);
    }, {
      once: true
    });
  }
};

/**
 * @deprecated Before page load, the data collection is automatic for HTMLElement with [data-tcvars] selector. If you want to push data at runtime, extend `lm.Composant` and do `this.componentTcVarsReady({ tcvars: YOUR_DATA })`.
 * Function to send the component tc_vars data to global lmfr-TMS-module component
 * @param {HTMLElement} component Object component with keys / values to insert in [data-tcvars] selector
 */
export var appendToTcVarsGlobal = function appendToTcVarsGlobal(component) {
  if (component.target.dataset.tcvars) {
    component.componentTcVarsReady({
      tcvars: JSON.parse(component.target.dataset.tcvars.replace(/'/g, '"'))
    });
  }
};

/**
 * @deprecated At runtime, extend `lm.Composant` and do `this.componentTcVarsReady({ tcvars: YOUR_DATA })`.
 * Fonction d'ajout au data-tcvars d'un composant avant aggrégation en javascript (utile notamment pour les actions asynchrones qui permettraient de renseigner le data-tcvars)
 * @param {HTMLElement} objectToAppend Object component with keys / values to insert in [data-tcvars] selector
 */
export var appendToTcVarsComponent = function appendToTcVarsComponent(objectToAppend) {
  if (_typeof(objectToAppend) !== 'object') {
    return;
  }
  var updatedTcVars = [];
  if (this.target.dataset.tcvars) {
    var fixedTcVars = this.target.dataset.tcvars.replace(/'/g, '"');
    updatedTcVars = JSON.parse("[".concat(fixedTcVars, "]"));
  }
  updatedTcVars.push(objectToAppend);
  this.target.dataset.tcvars = JSON.stringify(updatedTcVars);
};